import React from 'react';

import UserList from '../components/user/list';

export default class UserPage extends React.Component{
	render(){
		return (
			<div style={{ margin: 16 }}>
				<UserList page={ this.props.match.params.page }/>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/containers/user-page.js